import { VERIFICATION_BUCKETS, type VerificationBucket } from '@dcc-erp/shared';

export interface SupplierVerifyRow {
  id: string;
  nameTh: string;
  taxId: string | null;
  rdVerdict: string | null;
  rdVerifiedAt: string | null;
}

const FRESH_DAYS = 30; // mirror RD_VERIFY_TTL_DAYS

export function bucketOf(r: SupplierVerifyRow): VerificationBucket {
  if (!r.rdVerdict || r.rdVerdict === 'DISABLED') return 'UNVERIFIED';
  const stale =
    !r.rdVerifiedAt || Date.now() - new Date(r.rdVerifiedAt).getTime() > FRESH_DAYS * 86_400_000;
  if (r.rdVerdict === 'VERIFIED') return stale ? 'EXPIRED' : 'VERIFIED';
  if (r.rdVerdict === 'NAME_MISMATCH') return 'NAME_MISMATCH';
  if (r.rdVerdict === 'BRANCH_MISMATCH') return 'BRANCH_MISMATCH';
  if (r.rdVerdict === 'NOT_VAT_REGISTERED' || r.rdVerdict === 'INVALID_TAX_ID')
    return 'NOT_VAT_REGISTERED';
  return 'UNVERIFIED'; // UNKNOWN
}

const META: Record<VerificationBucket, { label: string; cls: string }> = {
  VERIFIED: { label: 'ยืนยันแล้ว', cls: 'positive' },
  NAME_MISMATCH: { label: 'ชื่อไม่ตรง', cls: 'warning' },
  BRANCH_MISMATCH: { label: 'สาขาไม่ตรง', cls: 'warning' },
  NOT_VAT_REGISTERED: { label: 'ไม่ได้จด VAT', cls: 'negative' },
  EXPIRED: { label: 'ต้องตรวจซ้ำ', cls: 'neutral' },
  UNVERIFIED: { label: 'ยังไม่ตรวจ', cls: 'neutral' },
};

export function VerificationDashboard({
  rows,
  active,
  onPickBucket,
}: {
  rows: SupplierVerifyRow[];
  active?: VerificationBucket | null;
  onPickBucket: (b: VerificationBucket | null) => void;
}) {
  const counts = Object.fromEntries(VERIFICATION_BUCKETS.map((b) => [b, 0])) as Record<
    VerificationBucket,
    number
  >;
  for (const r of rows) counts[bucketOf(r)] += 1;
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {VERIFICATION_BUCKETS.map((b) => (
        <button
          key={b}
          type="button"
          data-testid={`chip-${b}`}
          className={`badge ${META[b].cls}`}
          style={{
            cursor: 'pointer',
            opacity: active && active !== b ? 0.5 : 1,
            border: active === b ? '2px solid var(--brand)' : undefined,
          }}
          onClick={() => onPickBucket(active === b ? null : b)}
        >
          {META[b].label} <b data-testid={`count-${b}`}>{counts[b]}</b>
        </button>
      ))}
    </div>
  );
}
